import { defineStore } from "pinia";

export const ACCESS_GROUP_KEY = "accessGroup";

export const useAccessGroupStore = defineStore("accessGroup", () => {
  // We use localStorage to persist the access group
  const accessGroup = ref(localStorage.getItem(ACCESS_GROUP_KEY) || "");

  watch(accessGroup, (value) => {
    localStorage.setItem(ACCESS_GROUP_KEY, value);
  });

  return {
    accessGroup,
  };
});
